<ng-container *ngIf="actualPage">
  <div class="offerView">
    <ng-container *ngIf="actualPage.viewFile">
      <div class="mb-5">
        <img [ngSrc]="actualPage.viewFile.src"
             [width]="imageService.width"
             [height]="imageService.height"
             [priority]="true"
             [alt]="actualPage.viewFile.altText">
      </div>
    </ng-container>
    <ng-container *ngIf="actualPage.viewDescription">
      <div class="mb-5">
        <div class="offerViewDescription" [innerHtml]="actualPage.viewDescription"></div>
      </div>
    </ng-container>
  </div>
</ng-container>

<div class="row" [className]="CssPropertiesEnum.offerHeaderClasses|cssProperty: vHostService" id="offerHeader">
  <div class="col-12">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('offer_intro')"
        [innerHTML]="translationService.getTranslation('offer_intro')"></h3>
  </div>
  <div class="col-12" >
    <h4 [innerHTML]="translationService.getTranslation('offer_description')"></h4>
  </div>
</div>
<div class="row mb-3">
  <div class="col-12" id="offerErrors">
    <app-general-errors [errors]="errorsArr"></app-general-errors>
    <div *ngIf="isLoadingOffer" style="text-align: center;" id="offerSpinner">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
</div>

<div class="offerPage" id="offers">
  <div class="row">
    <ng-container *ngFor="let offer of offers">
      <div *ngIf="activeGroup === offer.offerGroup" [className]="
                  'col-' + (CssPropertiesEnum.offerFxFlex|cssProperty: vHostService) + ' ' +
                  'col-sm-' + (CssPropertiesEnum.offerFxFlexSM|cssProperty: vHostService) + ' ' +
                  'col-md-' + (CssPropertiesEnum.offerFxFlexMD|cssProperty: vHostService) + ' ' +
                  'col-lg-' + (CssPropertiesEnum.offerFxFlexLG|cssProperty: vHostService) + ' ' +
                  'col-xl-' + (CssPropertiesEnum.offerFxFlexXL|cssProperty: vHostService) + ' ' +
                  'col-xxl-' + (CssPropertiesEnum.offerFxFlexXXL|cssProperty: vHostService) + ' mb-5'">
        <app-offer-card [offer]="offer"></app-offer-card>
      </div>
    </ng-container>

    <ng-container *ngFor="let externalOffer of externalOffers">
      <div [className]="
                  'col-' + (CssPropertiesEnum.offerFxFlex|cssProperty: vHostService) + ' ' +
                  'col-sm-' + (CssPropertiesEnum.offerFxFlexSM|cssProperty: vHostService) + ' ' +
                  'col-md-' + (CssPropertiesEnum.offerFxFlexMD|cssProperty: vHostService) + ' ' +
                  'col-lg-' + (CssPropertiesEnum.offerFxFlexLG|cssProperty: vHostService) + ' ' +
                  'col-xl-' + (CssPropertiesEnum.offerFxFlexXL|cssProperty: vHostService) + ' ' +
                  'col-xxl-' + (CssPropertiesEnum.offerFxFlexXXL|cssProperty: vHostService)">
      <app-external-offer-card [externalOffer]="externalOffer"></app-external-offer-card>
      </div>
    </ng-container>
  </div>
  <div class="mt-5 float-end">
    <button mat-raised-button
            (click)="goBackToGroupView()" [innerHTML]="translationService.getTranslation('button_back')"></button>
  </div>
</div>

